"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_redux_1 = require("react-redux");
var usePlayerId_1 = __importDefault(require("../Hooks/usePlayerId"));
var GameMode_1 = __importDefault(require("../Types/GameMode"));
var GiveUp_1 = require("./GiveUp");
function useGiveUp() {
    var dispatch = react_redux_1.useDispatch();
    var giveUp = function () { return dispatch(GiveUp_1.giveUpAction); };
    var playerId = usePlayerId_1.default();
    var gameOver = react_redux_1.useSelector(function (state) { return state.gameOver; });
    var gameMode = react_redux_1.useSelector(function (state) { return state.gameMode; });
    var canGiveUp = playerId !== undefined && !gameOver && gameMode !== GameMode_1.default.TUTORIAL;
    return [giveUp, canGiveUp];
}
exports.default = useGiveUp;
//# sourceMappingURL=useGiveUp.js.map